import React, { FC } from 'react';

import {
  Text,
  Flex,
  Stack,
  Avatar,
  Center,
  Spinner,
  // Button,
  // Collapse,
  // useDisclosure,
} from '@chakra-ui/react';

import { format } from 'date-fns';
import { useQuery } from 'react-query';

import { fetchOrderHistory } from 'api/order';

import { Status } from 'types/items';

type Props = {
  orderId: string;
};

export const OrderHistory: FC<Props> = ({ orderId }) => {
  const queryKey = `fetch-order-history-${orderId}`;
  const queryFn = () => fetchOrderHistory(orderId);
  const options = { enabled: !!orderId };

  const { data = [], isLoading } = useQuery<any[]>(queryKey, queryFn, options);

  return (
    <Flex
      px="10px"
      pb="20px"
      h="100%"
      maxH="400px"
      direction="column"
      overflow="auto">
      {isLoading ? (
        <Center p={20}>
          <Spinner size="lg" />
        </Center>
      ) : data?.length > 0 ? (
        <Stack mt={2}>
          {data?.map((order) => {
            return <OrderItem key={`${order?._id}`} order={order} />;
          })}
        </Stack>
      ) : (
        <Center p={10}>
          <Text>No Data</Text>
        </Center>
      )}
    </Flex>
  );
};

const OrderItem: FC<{ order: any }> = ({ order }) => {
  // const { isOpen, onToggle } = useDisclosure();

  return (
    <Flex
      mb={2}
      bg="#fff"
      overflow="hidden"
      direction="column"
      borderRadius="10px"
      boxShadow="0 0 10px 0px rgba(0,0,0,0.1)">
      <Flex p="10px 20px" gap="20px" borderBottom="1px solid #ccc">
        <Avatar />
        <Stack spacing={0}>
          <Text fontSize="14px" fontWeight="semibold">
            {order?.performedBy?.[0]?.fname}
          </Text>
          <Text fontSize="14px">
            {order?.performedBy?.[0]?.permissions?.[0]?.role}
          </Text>
        </Stack>
        <Stack flex={1} spacing={0} align="flex-end">
          <Text fontSize="14px">Transaction</Text>
          <Text fontSize="14px" fontWeight="bold">
            #{order?._id || ''}
          </Text>
        </Stack>
        <Stack spacing={0} align="flex-end">
          <Text fontSize="14px" noOfLines={1}>
            {format(new Date(order?.updatedAt), 'HH:mm a')}
          </Text>
          <Text fontSize="14px" noOfLines={1}>
            {new Date(order?.updatedAt).toDateString()}
          </Text>
        </Stack>
      </Flex>

      <Flex p="20px" align="center" justify="space-between">
        <Text fontSize="14px">
          Changed the item status to "{Status[order?.status]}"
        </Text>
        {/* <Button
          as="button"
          color="primary.500"
          variant="ghost"
          onClick={onToggle}>
          {isOpen ? 'See Less Details' : 'See More Details'}
        </Button> */}
      </Flex>

      {/* <Collapse in={isOpen} animateOpacity unmountOnExit>
        <Flex animation="1s ease-in-out" direction="column">
          <Flex
            p="20px"
            fontSize="14px"
            color="primary.300"
            fontWeight="600"
            bg="surface.400">
            <Text flex={1}>Item ID</Text>
            <Text flex={1}># Items</Text>
            <Text flex={1}>SKU</Text>
            <Text flex={1}>Type</Text>
            <Text flex={1}>Size (Oz)</Text>
          </Flex>
          <Flex
            p="20px"
            fontSize="14px"
            color="primary.300"
            fontWeight="600"
            bg="#fff">
            <Text flex={1}>Item ID</Text>
            <Text flex={1}># Items</Text>
            <Text flex={1}>SKU</Text>
            <Text flex={1}>Type</Text>
            <Text flex={1}>Size (Oz)</Text>
            <Text>What data to show here?</Text>
          </Flex>
        </Flex>
      </Collapse> */}
    </Flex>
  );
};
